import ManageAccount from 'features/accounts/ManageAccount/ManageAccount';
import React from 'react';

export default function ExternalAccountDetailsPage() {
  return <ManageAccount />;
}
